import SelectFx from '../vendors/selectFx.min';

export default function postsFilter () {
    const filters_container = document.querySelector('.posts-filter');

    if (typeof (filters_container) !== 'undefined' && filters_container !== null) {
        const els = filters_container.querySelectorAll('select');

        els.forEach(el => {
            el.classList.add('custom-select');
            const select = new SelectFx(el, {     // eslint-disable-line
                stickyPlaceholder: false,
                onChange: (val) => {
                    window.location.href = val;
                }
            });
        });
    }
}
